import React, { useEffect, useState } from "react";
import AdminDashboard from "../AdminDashboard";
import { Alert, Dropdown, Spinner, Table } from "react-bootstrap";
import PagePagination from "../../../Components/Body/PagePagination";
import MainSearch from "../../../Components/Body/MainSearch";
import { Link, useLocation } from "react-router-dom";
import axios from "axios";
import { basicConfigMultipart } from "../../../constants";
import { Check, ThreeDots, X } from "react-bootstrap-icons";
import { localizeDate } from "../../../methods/formatDate";

const per_page_limit = 10;

const AllOrders = () => {
  const location = useLocation();

  const urlParams = new URLSearchParams(location.search);

  const search = urlParams.get("q");

  const page = urlParams.get("page") || 1;

  const [pages, setPages] = useState(1);

  const [loading, setLoading] = useState(true);

  const [showError, setShowError] = useState(false);

  const [orersCount, setOrdersCount] = useState(1);

  const [ordersList, setOrdersList] = useState([]);

  useEffect(() => {
    const fetchOrders = async (search, per_page_limit) => {
      setShowError(false);
      setLoading(true);

      let formData = new FormData();

      formData.append("limit", per_page_limit);
      formData.append("page", page);

      if (search && search.trim().length > 0) {
        formData.append("q_search", search);
      }

      await axios
        .post(
          `${process.env.REACT_APP_API_URL}/orders/filter/`,
          formData,
          basicConfigMultipart
        )
        .catch((_) => {
          setShowError(true);
        })
        .then((response) => {
          if (response && response.status === 200) {
            setOrdersCount(response.data["count"]);
            setOrdersList(response.data["orders"]);
          } else {
            setShowError(true);
          }
        });

      setLoading(false);
    };

    fetchOrders(search, per_page_limit);
  }, [page, search]);

  useEffect(() => {
    setPages(Math.ceil(orersCount / per_page_limit));
  }, [orersCount]);

  return (
    <AdminDashboard>
      <>
        {showError && (
          <Alert
            variant="danger"
            onClose={() => {
              setShowError(false);
            }}
            dismissible
          >
            <Alert.Heading>Error fetching.</Alert.Heading>
          </Alert>
        )}
        {loading && <Spinner animation="grow" />}
        <div className="admin_content">
          <div className="admin_content_header">
            <h4>All Orders</h4>
          </div>
          {/* place a searchbox here */}
          <MainSearch />

          <div className="admin_content_content">
            <Table striped hover>
              <thead>
                <tr>
                  <th>#Id</th>
                  <th>Customer</th>
                  <th>Date Created</th>
                  <th>Status</th>
                  <th>Total</th>
                  <th>Paid</th>
                  <th>Shipping</th>
                  <th>Line Items</th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                {ordersList.map((order, index) => {
                  return (
                    <tr key={index}>
                      <td>{order?.id}</td>
                      <td>
                        <Link to={`/admin/orders/${order?.customer}`}>
                          {order?.customer}
                        </Link>
                      </td>
                      <td>{localizeDate(order?.date_created_gmt)}</td>
                      <td
                        style={{
                          color:
                            order?.status === "pending"
                              ? "orange"
                              : order?.status === "completed"
                              ? "green"
                              : "black",
                        }}
                      >
                        {order?.status}
                      </td>
                      <td>{order?.total}</td>
                      <td>
                        {!(order?.needs_payment ?? true) &&
                        order?.date_paid_gmt !== null ? (
                          <Check />
                        ) : (
                          <X color="red" />
                        )}
                      </td>
                      <td>{order?.shipping != null && <Check />}</td>
                      <td>{(order?.line_items ?? []).length}</td>
                      <td>
                        <Dropdown>
                          <Dropdown.Toggle>
                            <ThreeDots />
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            <Dropdown.Item
                              as={Link}
                              role=""
                              to={`/admin/orders/order/${order?.id}`}
                            >
                              View Order
                            </Dropdown.Item>
                            {order?.status === "pending" && (
                              <Dropdown.Item>Cancel Order</Dropdown.Item>
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>

            <PagePagination page={parseInt(page) || 1} pages={pages} />
          </div>
        </div>
      </>
    </AdminDashboard>
  );
};

export default AllOrders;
